<template lang="html">
  <section class="app-update-gallery">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <p v-if="!getCurrentElement">
      Please go first to the "<a href="#" @click="navigateAway('read')"><strong><em>Read</em></strong></a>"
      tab and select the gallery you would like to update.
    </p>
    <form v-else @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="d-flex flex-wrap mb-3">
        <div v-if="displayMessage" class="font-size-larger font-weight-bold">
          <span :class="successUploaded ? 'text-success' : 'text-danger'" v-html="message"></span>
        </div>
        <div class="d-flex" v-if="fileToUpload">
          <div class="" v-show="imageShow">
            <div>{{ fileName }}</div>
            <div>
              <img class="img-thumbnail w-80" :alt="fileToUpload.name" :src="fileToRead" />
            </div>
          </div>
          <div v-if="!imageShow" class="d-flex align-self-center">
            <button type="button" class="btn btn-outline-dark mt-1 mb-1 ml-3" @click="showHideImage">
              Show File
            </button>
            <button v-if="displayMessage" type="button" class="btn btn-outline-danger mt-1 mb-1 ml-3" @click="onRemoveFile">
              Remove File
            </button>
            <button v-if="!displayMessage" type="button" class="btn btn-outline-success mt-1 mb-1 ml-3" @click="onUploadFile">
              Upload File
            </button>
            <button v-if="!displayMessage" type="button" class="btn btn-outline-warning mt-1 mb-1 ml-3" @click="replaceImage">
              Replace File
            </button>
          </div>
          <div v-if="imageShow" class="d-flex align-self-center">
            <button type="button" class="btn btn-outline-dark mt-1 mb-1 ml-3" @click="showHideImage">
              Hide
            </button>
            <button v-if="displayMessage" type="button" class="btn btn-outline-danger mt-1 mb-1 ml-3" @click="onRemoveFile">
              Remove
            </button>
            <button v-if="!displayMessage" type="button" class="btn btn-outline-success mt-1 mb-1 ml-3" @click="onUploadFile">
              Upload
            </button>
            <button v-if="!displayMessage" type="button" class="btn btn-outline-warning mt-1 mb-1 ml-3" @click="replaceImage">
              Replace
            </button>
          </div>
        </div>
      </div>
      <div class="custom-file mb-3" v-if="!fileToUpload">
        <input :class="(inputFileTouched && !fileName) ? 'is-invalid': ''" @blur="inputFileTouched = true" lang="en"
               type="file" id="fileToUpload" ref="fileToUpload" @change="handleFileToUpload"
               accept=".jpeg, .jpg, .png" class="custom-file-input" required>
        <label class="custom-file-label" for="fileToUpload">* Choose file</label>
        <div class="invalid-feedback">
          <div>Please add an image file for your gallery !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="galleryType" class="w-25 align-self-center">* Type :</label>
        <div class="w-100">
          <select :class="$v.dataForm.galleryType.$error ? 'is-invalid': ''"
                  @blur="$v.dataForm.galleryType.$touch()"
                  v-model="dataForm.galleryType" id="galleryType" class="custom-select">
            <option :value="galleryType" :key="idx" class="text-capitalize"
                    v-for="(galleryType, idx) of getGalleriesTypes">
              {{galleryType }}
            </option>
          </select>
          <div class="invalid-feedback">Please enter gallery type !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="galleryLink" class="w-25 align-self-center">* Link :</label>
        <div class="w-100">
          <input :class="$v.dataForm.galleryLink.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.galleryLink.$touch() ||
                 (dataForm.galleryLink = (dataForm.galleryLink === '') ?
                 savedData.link : dataForm.galleryLink)"
                 v-model="dataForm.galleryLink" type="text" class="form-control" id="galleryLink">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.galleryLink.required">Please provide a link !</div>
            <div v-if="!$v.dataForm.galleryLink.minLength">
              Please provide a valid link ! (link must have at least
              {{$v.dataForm.galleryLink.$params.minLength.min}} characters)
            </div>
            <div v-if="!$v.dataForm.galleryLink.maxLength">
              Try to shorten your link ! (link exceed the number of characters allowed
              ({{$v.dataForm.galleryLink.$params.maxLength.max}}))
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="galleryTitle" class="w-25 align-self-center">* Title :</label>
        <div class="w-100">
          <input :class="$v.dataForm.galleryTitle.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.galleryTitle.$touch() ||
                 (dataForm.galleryTitle = (dataForm.galleryTitle === '') ?
                 savedData.title : dataForm.galleryTitle)"
                 v-model="dataForm.galleryTitle" type="text" class="form-control" id="galleryTitle">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.galleryTitle.minLength">
              Please provide a valid title ! (title must have at least
              {{$v.dataForm.galleryTitle.$params.minLength.min}} characters)
            </div>
            <div v-if="!$v.dataForm.galleryTitle.maxLength">
              Try to give a short title ! (characters must not exceed
              ({{$v.dataForm.galleryTitle.$params.maxLength.max}}))
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="gallerySrc" class="w-25 align-self-center">* Source :</label>
        <div class="w-100">
          <input :class="$v.dataForm.gallerySrc.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.gallerySrc.$touch() ||
                 (dataForm.gallerySrc = (dataForm.gallerySrc === '') ?
                 savedData.src : dataForm.gallerySrc)"
                 v-model="dataForm.gallerySrc" type="text" class="form-control" id="gallerySrc">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.gallerySrc.required">Please provide a source !</div>
            <div v-if="!$v.dataForm.gallerySrc.minLength">
              Please provide a valid source ! (source must have at least
              {{$v.dataForm.gallerySrc.$params.minLength.min}} characters)
            </div>
            <div v-if="!$v.dataForm.gallerySrc.maxLength">
              Try to shorten your source ! (source exceed the number of characters allowed
              ({{$v.dataForm.gallerySrc.$params.maxLength.max}}))
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="galleryDescription" class="w-25 align-self-center">Description :</label>
        <div class="w-100">
          <textarea :class="$v.dataForm.galleryDescription.$error ? 'is-invalid': ''"
                    @blur="$v.dataForm.galleryDescription.$touch() ||
                    (dataForm.galleryDescription = (dataForm.galleryDescription === '') ?
                    savedData.description : dataForm.galleryDescription)"
                    v-model="dataForm.galleryDescription" class="form-control" id="galleryDescription"
                    placeholder="Enter description here...">
          </textarea>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.galleryDescription.minLength">
              Your description is to short ({{$v.dataForm.galleryDescription.$params.minLength.min}} characters) !
              Try to enter more words !
            </div>
            <div v-if="!$v.dataForm.galleryDescription.maxLength">
              Number of characters exceeded ! ({{$v.dataForm.galleryDescription.$params.maxLength.max}} characters)
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                :disabled="$v.dataForm.$invalid" type="submit" class="btn btn-success">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
import {FORM_GALLERIES_VALIDATIONS} from '../../validations/formGalleries'
export default {
  name: 'UpdateGallery',
  props: [],
  mounted () {},
  created () {
    this.readOneData()
      .then(data => {
        this.savedData = data;
        this.dataForm.galleryType = this.savedData.type;
        this.dataForm.galleryLink = this.savedData.link;
        this.dataForm.gallerySrc = this.savedData.src;
        this.dataForm.galleryDescription = this.savedData.description;
        this.dataForm.galleryTitle = this.savedData.title;
        this.fileToRead = (this.getBaseURL + this.savedData.src);
        this.fileToUpload = true;
        this.fileName = this.savedData.name;
      })
      .catch()
  },
  validations: FORM_GALLERIES_VALIDATIONS,
  data () {
    return {
      savedData : null,
      dataForm: {
        galleryType : undefined,
        galleryLink : undefined,
        gallerySrc : undefined,
        galleryDescription : undefined,
        galleryTitle : undefined
      },
      inputFileTouched: false,
      fileToRead: null,
      fileToUpload: null,
      fileName: undefined,
      imageShow: true,
      displayMessage: false,
      message: "",
      messageSubmission: "",
      successUploaded: false
    }
  },
  watch: {
    message : function () {
      let vm = this;
      setTimeout( () => vm.message = "", 5000)
    }
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setCrudComponent',
      'uploadFile',
      'removeFile',
      'readOneData',
      'updateData'
    ]),
    navigateAway(tab) {
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    },
    onSubmit () {
      const formData = {
        gallery_id : (this.getCurrentElement) ? this.getCurrentElement.id : '',
        type: this.dataForm.galleryType,
        link: this.dataForm.galleryLink,
        src: this.dataForm.gallerySrc,
        description: this.dataForm.galleryDescription,
        title: this.dataForm.galleryTitle
      };
      this.updateData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => this.messageSubmission = '', 5000);
        })
        .catch()
    },
    resetForm () {
      this.dataForm.galleryType = this.savedData.type;
      this.dataForm.galleryLink = this.savedData.link;
      this.dataForm.gallerySrc = this.savedData.src;
      this.dataForm.galleryDescription = this.savedData.description;
      this.dataForm.galleryTitle = this.savedData.title;
      this.fileToRead = (this.getBaseURL + this.savedData.src);
      this.fileToUpload = true;
      this.fileName = this.savedData.name;
    },
    handleFileToUpload () {
      let fileList = this.$refs.fileToUpload.files;
      this.fileToUpload = (fileList.length === 0) ? null : fileList[0];
      this.fileName = (this.fileToUpload !== null) ? this.fileToUpload.name : undefined;
      this.createImage(this.fileToUpload)
    },
    showHideImage () {
      this.imageShow = !this.imageShow
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.fileToRead = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    replaceImage () {
      this.fileToUpload = null;
      this.imageShow = true;
      this.message = '';
      this.displayMessage = false;
    },
    onRemoveFile () {
      this.removeFile(this.dataForm.gallerySrc)
        .then(data => {
          this.updateDataVariables(data[0], data[1], data[2]);
          setTimeout( () => this.replaceImage(), 5000)
        })
        .catch();
    },
    updateDataVariables (bool, text, src) {
      this.successUploaded = bool;
      this.displayMessage = true;
      this.imageShow = false;
      this.message = text;
      this.dataForm.gallerySrc = src;
    },
    onUploadFile () {
      let formImage = new FormData();
      formImage.append('fileToUpload', this.fileToUpload);
      formImage.append('from', this.getComponent);
      formImage.append('submit', '');
      this.uploadFile(formImage)
        .then(data => this.updateDataVariables(data[0], data[1], data[2]))
        .catch(data => this.updateDataVariables(data[0], data[1], data[2]))
    }
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getGalleriesTypes',
      'getCurrentElement',
      'getBaseURL'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-update-gallery {}
</style>



// WEBPACK FOOTER //
// src/components/galleries/UpdateGallery.vue